import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { RootState } from '@/models/index';
import CloseTag from '@/components/close-tag';
import styles from './index.module.scss';

export default function SelectdTag() {
  const dispatch = useDispatch();
  const { filterData } = useSelector<RootState, RootState['brand']>(state => state.brand);
  const handleClear = () => {
    for (let index = 0; index < document.querySelectorAll('a[data-class="all_type_class"]').length; index++) {
      (document.querySelectorAll('a[data-class="all_type_class"]')[index] as any)?.click();
    }
    dispatch({ type: 'brand/setFilterData', payload: [] });
  };
  const handleClose = id => {
    const ids = filterData.filter(item => item.id !== id);
    dispatch({ type: 'brand/setFilterData', payload: ids });
    id && document.getElementById(id)?.click();
    // id && document.getElementById(id)?.click();
  };
  return (
    <div className={classNames('flex-row-nowrap', styles.selectedTag)}>
      <div className={styles.title}>已选标签：</div>
      <div className={classNames('flex-row-wrap')}>
        {filterData?.map((item, index) => (
          <CloseTag key={index} name={item.name} id={item.id} onClose={handleClose} />
        ))}
        {filterData?.length > 0 && (
          <div className={styles.clear} onClick={handleClear}>
            清除筛选
          </div>
        )}
      </div>
    </div>
  );
}
